function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Button/4Tabs/Contract",
  transform: "translate(-15.000000, -5.000000)",
  stroke: "#FFFFFF",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  id: "contract-wit",
  transform: "translate(16.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.8583333,12.3916667 L12.5,18.75 L9.375,19.375 L10,16.25 L16.3583333,9.89166667 C16.6887893,9.56069003 17.1372964,9.37470545 17.605,9.37470545 C18.0727036,9.37470545 18.5212107,9.56069003 18.8516667,9.89166667 L18.8583333,9.89833333 C19.18931,10.2287893 19.3752945,10.6772964 19.3752945,11.145 C19.3752945,11.6127036 19.18931,12.0612107 18.8583333,12.3916667 L18.8583333,12.3916667 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.125,5.625 L11.875,5.625",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.125,9.375 L11.875,9.375",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.125,13.125 L7.5,13.125",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.25,16.875 L1.875,16.875 C1.18464406,16.875 0.625,16.3153559 0.625,15.625 L0.625,1.875 C0.625,1.18464406 1.18464406,0.625 1.875,0.625 L10.7325,0.625 C11.0637893,0.625 11.3815013,0.75665146 11.6158333,0.990833333 L14.0091667,3.38416667 C14.2433485,3.61849866 14.375,3.93621066 14.375,4.2675 L14.375,6.875",
  id: "Path"
}))));
function SvgContractSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "contract wit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractSelected);
export default __webpack_public_path__ + "static/media/contract_selected.71b2459ec0234603679323f9123f8f95.svg";
export { ForwardRef as ReactComponent };